import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=66970552&scoped=true&"
import script from "./Positions.vue?vue&type=script&lang=js&"
export * from "./Positions.vue?vue&type=script&lang=js&"
import style0 from "./Positions.vue?vue&type=style&index=0&id=66970552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66970552",
  null
  
)

/* custom blocks */
import block0 from "./Positions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports